import { CustomModulesIcon } from 'foundations-assets/icons/components/CustomModulesIcon';
import { FlexColumnIcon } from 'foundations-assets/icons/components/FlexColumnIcon';
import { GroupModuleIcon } from 'foundations-assets/icons/components/GroupModuleIcon';
import { PartialIcon } from 'foundations-assets/icons/components/PartialIcon';
export const DEFAULT_WIDGET_ICON = CustomModulesIcon;
export const WIDGET_ICON_MAP = Object.freeze({
  widget_container: FlexColumnIcon,
  cell: GroupModuleIcon,
  virtual_cell: FlexColumnIcon,
  global_group: PartialIcon,
  global_widget: DEFAULT_WIDGET_ICON,
  section_delimiter: DEFAULT_WIDGET_ICON
});